import { render, staticRenderFns } from "./Institucional.vue?vue&type=template&id=44165443&scoped=true"
import script from "./Institucional.vue?vue&type=script&lang=js"
export * from "./Institucional.vue?vue&type=script&lang=js"
import style0 from "./Institucional.vue?vue&type=style&index=0&id=44165443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44165443",
  null
  
)

export default component.exports